import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContractIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_876_6937",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 40,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_876_6937)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.70075 35.8332C8.62353 35.8332 7.70964 35.4579 6.95909 34.7073C6.20853 33.9568 5.83325 33.0429 5.83325 31.9657V26.859H10.8333V4.1665H34.1666V31.9657C34.1666 33.0429 33.7913 33.9568 33.0408 34.7073C32.2902 35.4579 31.3799 35.8332 30.3099 35.8332H9.70075ZM30.3074 33.739C30.806 33.739 31.2249 33.5691 31.5641 33.2294C31.903 32.8894 32.0724 32.4682 32.0724 31.9657V6.26067H12.9274V26.859H28.5362V31.9711C28.5362 32.4719 28.7059 32.8918 29.0453 33.2307C29.3848 33.5696 29.8055 33.739 30.3074 33.739ZM15.3203 13.6748V11.5811H29.6795V13.6748H15.3203ZM15.3203 18.4828V16.3886H29.6795V18.4828H15.3203Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgContractIcon);
export { ForwardRef as ReactComponent };
